import styled from 'styled-components';

import { StyledSignupButton as DefaultStyledSignupButton } from './signup-button.styled.default';

export * from './signup-button.styled.default';

export const StyledSignupButton = styled(DefaultStyledSignupButton)`
  ${Styles.headerMobile} {
    background-color: ${p => p.theme.primaryBackground};
  }
`;
